// extracted by mini-css-extract-plugin
export default {"imageWrapper":"xz-z","videoWrapper":"yz-z","twoColumnImage":"zz-z","imageCarouselBtn":"Az-z","carouselNextBtn":"Bz-z","carouselPrevBtn":"Cz-z"};